// Mock Data for Infectious Diseases Category

const baseProducts = [
    {
        id: "med-infectious-1",
        name: "Rifampin 600mg",
        genericName: "Brand: Rifadin",
        indication: "Tuberculosis",
        price: "$52",
        originalPrice: "$450",
        savings: "88%",
        description: "An essential antibiotic used in combination with other medications to treat tuberculosis (TB). It works by killing the bacteria that cause the infection.",
        dosage: "Taken once daily on an empty stomach, either 1 hour before or 2 hours after a meal.",
        packaging: "Contains 30 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place. Protect from heat and light.",
        sideEffects: "Red-orange discoloration of urine/tears, nausea, vomiting, or liver enzyme elevation.",
        category: "Anti-mycobacterials (TB)"
    },
    {
        id: "med-infectious-2",
        name: "Voriconazole 200mg",
        genericName: "Brand: Vfend",
        indication: "Fungal Infections",
        price: "$640",
        originalPrice: "$3,800",
        savings: "83%",
        description: "A potent antifungal medication used to treat serious, invasive fungal infections, including invasive aspergillosis, which often affect immunocompromised patients.",
        dosage: "Taken orally twice daily, at least 1 hour before or 1 hour after a meal.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a tightly closed container.",
        sideEffects: "Visual disturbances, rash, fever, nausea, or liver toxicity.",
        category: "Antifungals"
    },
    {
        id: "med-infectious-3",
        name: "Isoniazid 300mg",
        genericName: "Brand: Nydrazid",
        indication: "Tuberculosis",
        price: "$12",
        originalPrice: "$100",
        savings: "88%",
        description: "A first-line antibiotic used alone to prevent active tuberculosis (TB) infections and in combination with other drugs to treat active TB.",
        dosage: "Usually taken once daily on an empty stomach.",
        packaging: "Contains 100 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from light and direct heat.",
        sideEffects: "Numbness in hands/feet, nausea, loss of appetite, or liver problems. Often taken with Vitamin B6.",
        category: "Anti-mycobacterials (TB)"
    },
    {
        id: "med-infectious-4",
        name: "Pyrazinamide 500mg",
        genericName: "Brand: Pyrazinamide",
        indication: "Tuberculosis",
        price: "$15",
        originalPrice: "$220",
        savings: "93%",
        description: "Used alongside other medications in the initial phase of treating active tuberculosis. It helps shorten the duration of the TB therapy.",
        dosage: "Taken daily or several times a week as prescribed. Take exactly as directed.",
        packaging: "Contains 100 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a well-closed container.",
        sideEffects: "Joint pain, upset stomach, or liver toxicity. Requires liver function monitoring.",
        category: "Anti-mycobacterials (TB)"
    },
    {
        id: "med-infectious-5",
        name: "Ethambutol 400mg",
        genericName: "Brand: Myambutol",
        indication: "Tuberculosis",
        price: "$20",
        originalPrice: "$280",
        savings: "93%",
        description: "An oral antibiotic given in combination therapies to treat tuberculosis (TB) and occasionally other mycobacterial infections.",
        dosage: "Taken once daily. Dose is based on body weight.",
        packaging: "Contains 100 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "Changes in vision (color blindness or blurred vision), joint pain, or stomach upset.",
        category: "Anti-mycobacterials (TB)"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-infectious-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Infectious Diseases and Viral Treatment",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of severe bacterial, fungal, or viral infections. Sourced from WHO-GMP certified facilities ensuring clinical efficacy.`,
            dosage: "Strictly as prescribed by your infectious disease specialist.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. Complete the entire course of medication.",
            category: "General Infectious Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const infectiousProducts = [...baseProducts, ...generateAlphabetMeds()];

export const infectiousHeroData = {
    title: "Infectious Diseases",
    subtitle: "Tuberculosis, fungal infections, and chronic infectious diseases",
    description: "Secure reliable, high-quality treatments for complex infectious diseases including TB, severe fungal infections, and viral conditions. Access vital antimicrobial therapies with significant savings globally.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "85%", label: "Average Savings" }
    ]
};

export const infectiousCategories = [
    "All Categories",
    "Anti-mycobacterials (TB)",
    "Antifungals",
    "Antivirals",
    "Broad-Spectrum Antibiotics",
    "General Infectious Care"
];

export const infectiousTrustBadges = [
    { text: "WHO-GMP Certified", icon: "ShieldCheck" },
    { text: "Bioequivalent Quality", icon: "Activity" },
    { text: "Secure Global Shipping", icon: "Globe" },
    { text: "Pharmacist Verified", icon: "UserCheck" }
];

export const infectiousFAQs = [
    {
        question: "Do I need a prescription to order infectious disease medications?",
        answer: "Yes. All antibiotics, antifungals, and antivirals require a valid prescription from a doctor to prevent antimicrobial resistance and ensure proper treatment."
    },
    {
        question: "Are these generic TB medications effective?",
        answer: "Absolutely. The generic Anti-mycobacterials we supply (like Isoniazid and Rifampin) are produced in strictly regulated, WHO-GMP certified facilities and are proven bioequivalent to brand-name drugs."
    },
    {
        question: "How long does shipping take for chronic infection medications?",
        answer: "Depending on your global location, shipping typically takes 7-14 business days. We provide tracking and rapid processing to ensure you do not miss doses of critical prolonged treatments."
    },
    {
        question: "Can I order a full course of treatment at once?",
        answer: "Yes, for conditions like Tuberculosis that require 6 to 9 months of treatment, we highly encourage ordering your prolonged supply in bulk to guarantee continuity of care."
    }
];

export const infectiousTestimonials = [
    {
        name: "Robert M.",
        country: "United States",
        savings: "$3,200 total",
        condition: "Tuberculosis",
        medication: "Rifampin / Isoniazid",
        text: "Getting a full course for TB in the US was going to bankrupt me even with insurance. The generics supplied here were identical and allowed me to complete my treatment stress-free."
    },
    {
        name: "Priya S.",
        country: "United Kingdom",
        savings: "$18,000 annually",
        condition: "Invasive Aspergillosis",
        medication: "Voriconazole",
        text: "The cost of Vfend post-transplant was overwhelming. Accessing the generic version of Voriconazole through MediSeller has been a massive financial relief without compromising my health."
    },
    {
        name: "Daniel J.",
        country: "Australia",
        savings: "$800 total",
        condition: "Mycobacterial Infection",
        medication: "Ethambutol / Pyrazinamide",
        text: "Very professional service. The pharmacy team ensured my multi-drug regimen was correct and the medications arrived promptly in excellent packaging."
    }
];

export const infectiousSectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Read how patients have successfully eradicated and managed severe infections through our pharmacy."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important information regarding the safe ordering of antimicrobial therapies."
    },
    midPageCTA: {
        title: "Need a Complex Multi-Drug Regimen?",
        description: "Our procurement team can source full treatment courses for TB, severe fungal infections, and chronic viral conditions at massive discounts.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Treatment Cost"
    },
    finalCTA: {
        title: "Eradicate Infection Safely and Affordably",
        description: "Do not delay critical antimicrobial treatment due to high costs. Secure your complete prescribed regimen today.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
